import type { DeploymentKind, Outcome } from '@store/api/deploymentsApi';

export const KIND_LABEL: Record<DeploymentKind, string> = {
  client: 'Client',
  dotnet: '.NET app',
  dotnet_runtime: '.NET runtime',
  os_packages: 'OS packages',
};

/** What a Deployment target's StatusChip shows: its Outcome once the Device has
 *  reported one, otherwise the live status of its command. */
export const targetStatus = (target: {
  outcome: Outcome | null;
  command_status: string | null;
}): string => target.outcome ?? target.command_status ?? 'unknown';

const last = (list: unknown) => (Array.isArray(list) ? list[list.length - 1] : undefined);

/** One line for what a Device reported: package counts for OS packages, the
 *  runtime move for the .NET runtime. "-" for anything else. */
export const commandResultSummary = (result: Record<string, unknown> | null): string => {
  if (!result) return '-';
  if ('package_count' in result) {
    return [
      `${result.package_count} package(s)`,
      result.reboot_required && 'reboot required',
      result.app_restarted && 'app restarted',
    ]
      .filter(Boolean)
      .join(' · ');
  }
  if ('channel' in result) {
    if (result.rolled_back) return 'rolled back';
    const after = last(result.runtimes_after);
    return after ? `${last(result.runtimes_before) || 'none'} → ${after}` : '-';
  }
  return '-';
};
